var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["product-meta/title.j2"] = require( "product-meta/title.j2" );
dependencies["product-meta/price.j2"] = require( "product-meta/price.j2" );
dependencies["product-meta/brand.j2"] = require( "product-meta/brand.j2" );
dependencies["product-meta/badges.j2"] = require( "product-meta/badges.j2" );
dependencies["product-meta/reviews.j2"] = require( "product-meta/reviews.j2" );
dependencies["product-meta/reviews-empty.j2"] = require( "product-meta/reviews-empty.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-meta.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "product/templates/product-meta.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("quickshopUrl")) {
var t_4 = t_1.quickshopUrl;
} else {
cb(new Error("cannot import 'quickshopUrl'")); return;
}
context.setVariable("quickshopUrl", t_4);
if(t_1.hasOwnProperty("productUrl")) {
var t_5 = t_1.productUrl;
} else {
cb(new Error("cannot import 'productUrl'")); return;
}
context.setVariable("productUrl", t_5);
if(t_1.hasOwnProperty("brandsUrl")) {
var t_6 = t_1.brandsUrl;
} else {
cb(new Error("cannot import 'brandsUrl'")); return;
}
context.setVariable("brandsUrl", t_6);
output += "\n\n";
var t_7;
t_7 = env.getFilter("default").call(context, runtime.contextOrFrameLookup(context, frame, "forFamilyProduct"),runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("isForFamilyProduct", t_7, true);
if(frame.topLevel) {
context.setVariable("isForFamilyProduct", t_7);
}
if(frame.topLevel) {
context.addExport("isForFamilyProduct", t_7);
}
output += "\n";
var t_8;
t_8 = (lineno = 3, colno = 21, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.product.isVintage",false]));
frame.set("isVintage", t_8, true);
if(frame.topLevel) {
context.setVariable("isVintage", t_8);
}
if(frame.topLevel) {
context.addExport("isVintage", t_8);
}
output += "\n\n<div class=\"js-product-meta\">\n\n    ";
output += "\n    <div class=\"";
if(!runtime.contextOrFrameLookup(context, frame, "isForFamilyProduct")) {
output += "s-product-meta";
;
}
output += " c-product-meta\">\n\n        ";
output += "\n        ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"product")),"isAvailable")) {
output += "\n\n            ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_medium") || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_large")) {
output += "\n\n                ";
env.getTemplate("product-meta/title.j2", false, "product/templates/product-meta.j2", null, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
t_9.render(context.getVariables(), frame, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
output += t_10
output += "\n\n                ";
env.getTemplate("product-meta/price.j2", false, "product/templates/product-meta.j2", null, function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
t_13.render(context.getVariables(), frame, function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
output += t_14
output += "\n\n            ";
})})})});
}
output += "\n\n            ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productMeta")),"brand") && !runtime.contextOrFrameLookup(context, frame, "isForFamilyProduct") && !runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"hideBrand")) {
output += "\n\n                ";
env.getTemplate("product-meta/brand.j2", false, "product/templates/product-meta.j2", null, function(t_19,t_17) {
if(t_19) { cb(t_19); return; }
t_17.render(context.getVariables(), frame, function(t_20,t_18) {
if(t_20) { cb(t_20); return; }
output += t_18
output += "\n\n            ";
})});
}
output += "\n\n            ";
if(!runtime.contextOrFrameLookup(context, frame, "isForFamilyProduct")) {
output += "\n\n                ";
env.getTemplate("product-meta/badges.j2", false, "product/templates/product-meta.j2", null, function(t_23,t_21) {
if(t_23) { cb(t_23); return; }
t_21.render(context.getVariables(), frame, function(t_24,t_22) {
if(t_24) { cb(t_24); return; }
output += t_22
output += "\n\n            ";
})});
}
output += "\n\n        ";
;
}
else {
output += "\n\n\n        ";
;
}
output += "\n\n    </div>\n\n    ";
if(!runtime.contextOrFrameLookup(context, frame, "isForFamilyProduct") && !runtime.contextOrFrameLookup(context, frame, "isVintage")) {
output += "\n\n        <div class=\"c-product-reviews__outer\" data-qa-reviews-meta>\n\n            ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productReviews")),"hasProductReviews")) {
output += "\n\n                ";
env.getTemplate("product-meta/reviews.j2", false, "product/templates/product-meta.j2", null, function(t_27,t_25) {
if(t_27) { cb(t_27); return; }
t_25.render(context.getVariables(), frame, function(t_28,t_26) {
if(t_28) { cb(t_28); return; }
output += t_26
output += "\n\n            ";
})});
}
else {
output += "\n\n                ";
env.getTemplate("product-meta/reviews-empty.j2", false, "product/templates/product-meta.j2", null, function(t_31,t_29) {
if(t_31) { cb(t_31); return; }
t_29.render(context.getVariables(), frame, function(t_32,t_30) {
if(t_32) { cb(t_32); return; }
output += t_30
output += "\n\n            ";
})});
}
output += "\n\n        </div>\n\n    ";
;
}
output += "\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-meta.j2"] , dependencies)